import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './FetchBaseQuery'

export const bankApi = createApi({
   reducerPath: 'bankApi',
   baseQuery: baseQueryWithReauth,
   tagTypes: ['Bank'],
   endpoints: (builder) => ({
      getBanks: builder.query({
         query: () => '/bank/list',
         providesTags: ['Bank'],
      }),

      getBankById: builder.query({
         query: (id) => `/bank/view/${id}`,
      }),

      createBank: builder.mutation({
         query: (payload) => ({
            url: '/bank/create',
            method: 'POST',
            body: payload,
         }),
         invalidatesTags: ['Bank'],
      }),

      updateBank: builder.mutation({
         query: ({ id, payload }) => ({
            url: `/bank/update/${id}`,
            method: 'PUT',
            body: payload,
         }),
         invalidatesTags: ['Bank'],
      }),

      deleteBank: builder.mutation({
         query: (id) => ({
            url: `/bank/delete/${id}`,
            method: 'DELETE',
         }),
         invalidatesTags: ['Bank'],
      }),
   }),
})

export const {
   useGetBanksQuery,
   useGetBankByIdQuery,
   useCreateBankMutation,
   useUpdateBankMutation,
   useDeleteBankMutation,
} = bankApi
